export default "__VITE_ASSET__DwlZF9TW__"